<template>
  <button v-on:click="buttonClicked()">{{ text }}</button>
</template>

<script>
export default {
  name: "Button",
  props: {
    text: String
  },
  methods: {
    buttonClicked: function() {
      this.$emit("button-clicked");
    }
  }
};
</script>

<style scoped>
button {
  background-color: royalblue;
  border: none;
  color: white;
  padding: 10px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

button:hover {
  background-color: navy;
}
</style>
